import Reveal, { Eyebrow } from "./Reveal";
import { IMAGES } from "@/lib/api";

const days = [
  ["01", "Conosci il tuo punto di partenza", "Foto e misure, non la bilancia."],
  ["02", "L'importanza di un'alimentazione equilibrata", "Vedersi meglio non è necessariamente tagliare calorie."],
  ["03", "Inizia ad allenarti con i pesi", "3 esercizi, 30 minuti, anche a casa."],
  ["04", "Impara a mangiare a sufficienza", "Perché le 1200 kcal ti bloccano."],
  ["05", "Il movimento quotidiano fa la differenza", "I passi che contano più del cardio."],
  ["06", "Recupero, sonno e gestione dello stress", "La parte del piano che nessuno ti dice."],
  ["07", "Costruisci le basi per continuare", "Come continuare da sola."],
];

const Day = ({ n, t, d, className = "" }) => (
  <div className={`bg-white border border-[#E5E1D8] rounded-3xl p-6 flex flex-col justify-between ${className}`} data-testid={`inside-day-${n}`}>
    <span className="font-display text-5xl text-[#C05746]/80 leading-none">{n}</span>
    <div className="mt-8">
      <p className="font-display text-2xl leading-tight">{t}</p>
      <p className="text-sm text-[#5A625C] mt-2">{d}</p>
    </div>
  </div>
);

export default function Inside() {
  return (
    <section className="py-24 sm:py-32 bg-[#EFEBE3]/60" data-testid="inside-section">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <Eyebrow>Cosa trovi dentro</Eyebrow>
          <h2 className="font-display text-4xl sm:text-5xl tracking-tight leading-[1.05] mt-4">Sette giorni. Un'abitudine alla volta.</h2>
        </Reveal>
        <Reveal delay={0.1} className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <Day n={days[0][0]} t={days[0][1]} d={days[0][2]} />
          <div className="relative rounded-3xl overflow-hidden min-h-[240px] sm:row-span-2 lg:col-span-2">
            <img src={IMAGES.training} alt="Allenamento con i pesi" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-x-0 bottom-0 p-6 bg-gradient-to-t from-[#1E231F]/80 to-transparent">
              <p className="font-display text-2xl text-white leading-tight">Un PDF di 11 pagine, da salvare sul telefono.</p>
            </div>
          </div>
          {days.slice(1, 3).map(([n, t, d]) => <Day key={n} n={n} t={t} d={d} />)}
          {days.slice(3).map(([n, t, d]) => <Day key={n} n={n} t={t} d={d} />)}
        </Reveal>
      </div>
    </section>
  );
}
